
import { ContainerBien } from "./localStyle";
import { useHistory } from "react-router";
import HeaderbarHome from "_+_Portal/_-_SegundoFactor/components/HeaderbarHome/HeaderbarHome";
import TokenBox from "_+_Portal/_-_SegundoFactor/components/TokenBox/TokenBox";

const Home = () => {
  const history = useHistory();
  const itemStorage = localStorage.getItem("dtoSegundoFactor");
  const itemDto = JSON.parse(itemStorage);

  const onClickVolver = () => {
    history.push("/");
  };
  return (
    <>
      <HeaderbarHome />
      <ContainerBien>
        <div className="container-texto-segundoFactor">
          <span>
            ¡Hola{" "}
            <span className="segundoFactor-textoBold">{itemDto.nombre}</span>!
          </span>
          <span>
            Con este
            <span className="segundoFactor-textoBold">
              {" "}
              token de seguridad{" "}
            </span>
            vas a poder ingresar a tus APPS de manera
            <span className="segundoFactor-textoBold"> más segura.</span>
          </span>
        </div>
        <TokenBox />
        <button className="btn-tokenbox" onClick={onClickVolver}>
          Volver al Portal
        </button>
      </ContainerBien>
    </>
  );
};

export default Home;
